import React, { useState, useMemo } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { MIND_PATTERNS_DATA_REPORTS, mind_pattern_sections } from '../../../core/constants';
import { mindPatternsStoreMPActions } from '../../../core/mind-patterns-storemp/actions';
import { getMindPatternsDataById } from '../../../core/mind-patterns';
import { Disclaimers } from '../common';
import { ModalLockedAssessment } from '../common/locks';
import { useDispatch } from 'react-redux';
import { trackingActions } from '../../../core/tracking';

import ReactGA from 'react-ga';

const ReportComplete = (props) => {
  const dispatch = useDispatch();
  const [ openModalLock, setOpenModalLock ] = useState(false);

  const { attentionTypes, areas, hanndleNext, reports, mind_pattern_id, saveMindPatternsStoreMP, user, mind_pattern_unsaved, changeUnsavedMindPattern, current_mind_pattern } = props;
  const item = reports.find(s_item => s_item.id === mind_pattern_id);
  
  const mindPatternsAreas = areas;
  const getDataArea = useMemo(() => (code) => {
      if (!mindPatternsAreas?.items?.size) return null;

      const area = mindPatternsAreas.items.find(mpArea => { return mpArea.code.toLowerCase() === code.toLowerCase() });
      return area;
  }, [mindPatternsAreas]);

  if (!reports || !mind_pattern_id)
    return null

  const mind_patterns = item.code.split("").map((mp, k) => {
    const area = getDataArea(mp);
    return (
      <div key={item.id + '_' + mp} className={`text-md-left p-md-3 p-2 border rounded border-${area?.name.toLowerCase()}`}>
        <div className='d-flex flex-column flex-md-row justify-content-between align-items-center'>
            <i className='mb-3'><img src={area?.icon} alt={area?.name} width="64" height="64" /></i>
            <div className={`mb-3 rounded-circle mind-pattern-area bg-${area?.name.toLowerCase()} ${area?.name.toLowerCase() !== "auditory" ? 'text-white' : ''}`}>{mp}</div>
        </div>
        <p className="mb-0 h4-md h5 text-capitalize">{area?.name}</p>
        <p className="h5-md h6 mb-0 text-muted font-weight-normal">{attentionTypes[k]}</p>
      </div>
    )
  })

  const handleSetNewMindPattern = (mindPattern) => {
    if(user?.has_mp_blocked){
      setOpenModalLock(true)
      return;
    }

    if(mind_pattern_unsaved && !user?.mind_pattern) {
      changeUnsavedMindPattern(mindPattern);
      hanndleNext(mind_pattern_sections.REPORT);
    }
    else {
      setThisMindPattern(mindPattern);
    }

    eventGA();
    ourTracking();
  }

  const setThisMindPattern = (reportSelected) => {
    hanndleNext(mind_pattern_sections.REPORT)
    saveMindPatternsStoreMP(reportSelected)
  }

  const eventGA = () => {
    ReactGA.event({
        category: 'Mind Patterns',
        action: 'Foreign report - set this as my mind pattern completed'
    })
  }

  const ourTracking = () => {
    dispatch(trackingActions.saveTrackingEvent({category: 'Mind Patterns', action: 'Foreign report - set this as my mind pattern completed'}))
  }

  return (
    <>
    <Row>
      <Col lg={{ size: 10 }} className='mx-auto'>
        <div className='p-md-3 rounded border-md'>
          <div className='mb-4 d-flex align-items-center'>
            <Button color='link' className="icon-back text-body p-0 mr-3 mb-1" onClick={() => hanndleNext(mind_pattern_sections.REPORT)}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="24" height="20" viewBox="0 0 24 20">
                <path d="M24,10c0,0.3-0.1,0.5-0.3,0.7C23.5,10.9,23.3,11,23,11H3.4l7.3,7.3c0.1,0.1,0.2,0.2,0.2,0.3
                C11,18.7,11,18.9,11,19c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2C10.3,20,10.1,20,10,20
                c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2l-9-9c-0.1-0.1-0.2-0.2-0.2-0.3C0,10.3,0,10.1,0,10c0-0.1,0-0.3,0.1-0.4
                c0.1-0.1,0.1-0.2,0.2-0.3l9-9C9.5,0.1,9.7,0,10,0c0.3,0,0.5,0.1,0.7,0.3C10.9,0.5,11,0.7,11,1c0,0.3-0.1,0.5-0.3,0.7L3.4,9H23
                c0.3,0,0.5,0.1,0.7,0.3C23.9,9.5,24,9.7,24,10z"/>
              </svg>
            </Button>
            <h1 className='libre-caslon-text-regular h3-md h4 mb-0'>{item.code === current_mind_pattern ? 'Your mind pattern report' : 'Other mind patterns'}</h1>
          </div>

          <Row>
            <Col lg={{ size: 9 }} className='mx-auto'>
                <div className='p-3 border rounded text-center mb-3'>
                  {item.code === current_mind_pattern ? 
                    <p className="text-center mb-3">Based on how you answered the questions in the Mind Pattern Inventory, your brain uses the {item.title}</p>
                    :
                    <p className="text-center mb-3">Go through this Mind Pattern inventory. If you feel this pattern represents you better, you can click on the button below and set it as your own instead of your current selection.</p>
                  }

                  <div className='mind-pattern-report-user mb-2'>{mind_patterns}</div>
                </div>
            </Col>
          </Row>

          <div className="mind-report-complete">
            <div ref={el => item.report = el} dangerouslySetInnerHTML={{ __html: item.report }}></div>
          </div>

          <div className="d-flex justify-content-center align-content-center">
              <Button color='outline-green-light' size="sm" className='mx-2' onClick={() => hanndleNext(mind_pattern_sections.REPORT)}>
                <i className='mr-2'>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="currentColor">
                <path d="M11.5,5c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2h-8l2.8,2.8c0.1,0.1,0.2,0.3,0.2,0.5S5.7,9.3,5.6,9.4
                  C5.5,9.5,5.3,9.6,5.1,9.6C5,9.6,4.8,9.5,4.7,9.4L0.7,5.5C0.7,5.4,0.6,5.3,0.6,5.3c0-0.1-0.1-0.2-0.1-0.3s0-0.2,0.1-0.3
                  s0.1-0.2,0.1-0.2l3.9-3.9c0.1-0.1,0.1-0.1,0.2-0.1S5,0.4,5.1,0.4s0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2
                  S5.8,1,5.8,1.1c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.2L2.8,4.3h8c0.2,0,0.3,0.1,0.5,0.2C11.4,4.7,11.5,4.8,11.5,5z"/>
                </svg>
                </i>
                Back to result page
                </Button>
              
              {current_mind_pattern !== item.code &&
                <>
                  <Button size="sm" color='green-light' onClick={() => { handleSetNewMindPattern(item.code) }} className={`mx-2 ${user?.has_mp_blocked ? 'disabled' : ''}`}>
                    <i className='mr-2'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill='currentColor'>
                    <path d="M12.7,4.4l-7,7c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1
                      L1.7,8.3C1.7,8.3,1.6,8.2,1.6,8.1C1.5,8,1.5,8,1.5,7.9s0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1
                      c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.1L5.3,10l6.5-6.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0.1,0.5,0.2
                      c0.1,0.1,0.2,0.3,0.2,0.5C12.9,4.1,12.8,4.3,12.7,4.4L12.7,4.4z"/>
                    </svg>
                    </i>
                    Set as my Mind Pattern
                  </Button>
                  <ModalLockedAssessment 
                    isOpen={openModalLock}  
                    close={() => setOpenModalLock(false) }
                    blockDays={user?.assessments_block_days}
                  />
                </>
              }
          </div>

        </div>
        <Disclaimers view="copyright" />
      </Col>
    </Row>
    </>

  )
}

//=====================================
//  CONNECT

const mapStateToProps = (state, props) => {
  const { mind_patterns_store_mp, user } = state;
  const reports = getMindPatternsDataById(state, MIND_PATTERNS_DATA_REPORTS)
  return {
    mindPatternsStoreMP: mind_patterns_store_mp,
    user,
    reports: reports.items
  };
};

const mapDispatchToProps = {
  saveMindPatternsStoreMP: mindPatternsStoreMPActions.mindPatternsSaveStoreMp,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportComplete);

